import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.area = this.el.querySelector('.followArea')

    this.top = this.area.offsetHeight / 2
    this.left = this.area.offsetWidth / 2
    this.targetTop = 0
    this.targetLeft = 0
    this.speed = 0.1
    this.isHover = false

    this.follower()
  }

  follower() {
    this.initEventListeners()
  }

  lerp(start, end, t) {
    return start * (1 - t) + end * t
  }

  updateCoordinates() {
    if (!this.isHover) return

    this.top = this.lerp(this.top, this.targetTop, this.speed)
    this.left = this.lerp(this.left, this.targetLeft, this.speed)

    this.el.style.setProperty('--follower-left', `${this.left}px`)
    this.el.style.setProperty('--follower-top', `${this.top}px`)

    window.requestAnimationFrame(this.updateCoordinates.bind(this))
  }

  initEventListeners() {
    this.area.addEventListener('mouseenter', (e) => {
      this.isHover = true
      this.updateCoordinates()
    })
    this.area.addEventListener('mousemove', (e) => {
      this.targetTop = e.offsetY
      this.targetLeft = e.offsetX
    })
    this.area.addEventListener('mouseleave', (e) => {
      this.isHover = false
    })
  }
}
